import React from 'react'
import { Box, Container, Grid } from '@material-ui/core'
import useScrollPosition from '@react-hook/window-scroll'

import AnimatedText from '../AnimatedText'
import AnimatedPhoneSet from '../AnimatedPhoneSet'
import PageForm from '../PageForm/PageForm'
import RichText from '../RichText'
import { useStyles } from './FooterForm.style'
import AppDownloadLink from '../AppDownloadLink/AppDownloadLink'

const FooterForm = ({ waitingList, path, pageContext, t }, ref) => {
  const {
    ctaDescription,
    ctaHeading,
    footerImage,
    form,
    downloadAppstoreUrl,
    downloadPlaystoreUrl,
    downloadAppGalleryUrl,
  } = waitingList

  const scrollY = useScrollPosition(60)
  const { slug } = pageContext
  const isBackgroundVisible =
    slug !== '/' ||
    (ref.current &&
      scrollY >= ref.current.offsetTop - ref.current.clientHeight / 25)
  const styles = useStyles({ isBackgroundVisible })

  return (
    <Box
      ref={form ? ref : null}
      id="footer-slash"
      className={styles.background}
    >
      {/* Get early access section  */}
      <Container>
        <Grid container className={styles.waitlistWrapper}>
          <Grid item md={6} xs={12}>
            <Box
              className={[
                styles.waitingListDescription,
                styles.waitingListRow,
              ].join(' ')}
            >
              <AnimatedText
                animationType="wavy"
                variant="h1"
                content={ctaHeading || ''}
                wrapperClass={styles.waitingListTitle}
              />
              {ctaDescription?.raw && (
                <RichText
                  document={JSON.parse(waitingList.ctaDescription.raw)}
                  variant="body1"
                  className={styles.ctaDescription}
                />
              )}
              {form && (
                <PageForm data={form} source={path} t={t} isFooterForm />
              )}
              {(downloadAppstoreUrl ||
                downloadPlaystoreUrl ||
                downloadAppGalleryUrl) && (
                <Box className={styles.formCta}>
                  {downloadAppstoreUrl && (
                    <AppDownloadLink link={downloadAppstoreUrl} />
                  )}
                  {downloadPlaystoreUrl && (
                    <AppDownloadLink link={downloadPlaystoreUrl} />
                  )}
                  {downloadAppGalleryUrl && (
                    <AppDownloadLink link={downloadAppGalleryUrl} />
                  )}
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item md={6} xs={12}>
            <Box
              className={[styles.waitingListForm, styles.waitingListRow].join(
                ' ',
              )}
            >
              {waitingList.footerImage && (
                <AnimatedPhoneSet
                  animationPath={
                    footerImage.bucketAnimationUrl ||
                    footerImage.image?.file?.url
                  }
                  placeholderPath={footerImage.bucketUrl}
                  style={styles.footerFormLottie}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default React.forwardRef(FooterForm)
